import React, { useEffect, useState, useRef } from 'react'
import { serviceUrl,genericHeaders } from '../../utils/apiConfig';
import axios from 'axios';
import {Dialog, DialogActions, DialogContent, Button } from '@mui/material';
import { DatePicker,LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { getCommentsValue, getLogHoursValue, generateDates, generateWeeks, handleCommentChange, handleHourChange, buildTimesheetStructure } from './WorkLog3';
import WeekCard from './WeekCard';
import checkCircle from '../../Icons/CheckCircle.svg'
import { getToken } from '../../services/Token';
import { getActorInfo, formatActorDate } from '../../utils/onBehalf';
import Loader from "../customComponents/customLoader";
import { useLazyGetTimeSheetsByIDQuery } from '../../api/timeSheetAPI';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const AdminWorkLog = () => {
  const [employees, setEmployees] = useState([]);
  const [employeeFilter, setEmployeeFilter] = useState({
    employeeId: "",
    date: "",
  });
  const [dataNotAvailable, setDataNotAvailable] = useState();
  const [daysVisible, setDaysVisible] = useState([]);
  const [weekData, setWeekData] = useState([]);
  const [datesData, setDatesData] = useState([]);
  const [timeSheet, setTimeSheet] = useState();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogComment, setDialogComment] = useState("");
  const [submitDialogOpen, setSubmitDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const approvalStatus = useRef("");
  const timesheetId = useRef("");
  const empIdfromLocalStorage = localStorage.getItem("Id");
  const roles = getToken("roles");
  const isAdminUser = roles ? roles.includes("ADMIN") : false;
  const [projectId, setProjectId] = useState([]);
  const [timeSheetDatesStatus, setTimeSheetDatesStatus] = useState([])
  const [timeSheetErrorData, setTimeSheetErrorData] = useState([])
  let { timesheetdata } = useParams();
  const [count , setCount] = useState(0)
  const navigate = useNavigate()
  const shoulShowBackButton = (timeSheet?.status === "SUBMITTED" || timeSheet?.status === "APPROVED" || timeSheet?.status === "REJECTED") && timesheetdata
  const [getTimesheetDatesStatus, { data: timesheetDatesData, isError: timeSheetError ,isLoading: timeSheetLoading, error }] =
    useLazyGetTimeSheetsByIDQuery();
  const toggleDaysVisibility = (index) => {
    setDaysVisible((prev) => {
      const newData = [...prev];
      newData[index] = !newData[index];
      return newData;
    });
  };

  const getEmployeeData = async () => {
    try {
      let response = await axios.get(`${serviceUrl}/api/dropdown/users`, { headers: genericHeaders() });
      setEmployees(response.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const getProjectData = async () => {
    setLoading(true);
    const Id = getToken("Id");
    try {
      let response = await axios.get(
        `${serviceUrl}/api/project/getAllProjects`,
        { headers: genericHeaders() }
      );
      if (response.status === 200) {
        setProjects(response.data);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const getProjectNamesByIds = (workLog, projects) => {
    return workLog.map((log) => {
      return log.projectIds
        .map((id) => {
          const project = projects.find((project) => project._id === id);
          return project ? project.project : null; // Return project name or null
        })
        .filter(Boolean); // Filter out any null values
    });
  };

   const handleProjects = (evt, index) => {
     const selectedValues = Array.isArray(evt.target.value)
       ? evt.target.value
       : [evt.target.value];
     const updatedProjectIds = [...projectId];
     updatedProjectIds[index] = selectedValues;
     setProjectId(updatedProjectIds);
   };

  const getProjectDataByEmpId = async (propID) => {
    setLoading(true);
    const Id = propID ? propID :employeeFilter.employeeId
    try {
      let response = await axios.get(
        `${serviceUrl}/api/project/getprojectsbyempid?employeeId=${Id}`,
        { headers: genericHeaders() }
      );
      if (response.status === 200) {
        setLoading(false);
        setProjects(response.data);
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const getEmployeelog = async (payload) => {
    try {
      let response = await axios.post(
        `${serviceUrl}/api/workLogManagement/getworklogbyfilter`,
        payload,
        { headers: genericHeaders() }
      );
      if (response.status === 200) {
        if (
          response.data.employeeWorkLog !== null &&
          response.data.employeeWorkLog.length > 0
        ) {
          setTimeSheet(response.data);
          timesheetId.current = response.data._id;
          setDataNotAvailable(false);
          const project = getProjectNamesByIds(
            response.data.employeeWorkLog,
            projects
          );
          const dataForApi = response.data?.employeeWorkLog?.map(
            (item) => item.projectIds
          );
          if (getIsEditable()) {
            setProjectId(project);
          } else {
            if (dataForApi?.length > 0) {
              setProjectId(project);
            } else {
              setProjectId([]);
            }
          }
           
        } else if (isAdminUser) {
          setTimeSheet(buildTimesheetStructure(payload.date));
          timesheetId.current = '';
          setProjectId([]);
          setDataNotAvailable(false);
        } else {
          setTimeSheet(null);
          setDataNotAvailable(true);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleFilter = (evt) => {
    let newData = { ...employeeFilter };
    if (evt?.target?.name === "employeeId") {
      newData.employeeId = evt.target.value;
    } else {
      let date = new Date(evt);
      date.setHours(0, 0, 0, 0);
      let selectedDate = new Date(
        date.getTime() - date.getTimezoneOffset() * 60000
      );
      newData.date = selectedDate.toISOString();
      getProjectDataByEmpId();
      setProjectId([]);
    }
    setEmployeeFilter(newData);
    if (newData.employeeId !== "" && newData.date !== "") {
      getEmployeelog(newData);
    }
  };

  const getApprovalStatus = (status) => {
    if (status === "approve") {
      return "APPROVED";
    } else if (status === "reject") {
      return "REJECTED";
    }
  };

  const getProjectID = (projectData) => {
    let projectNames = [...projects];
    return projectData.map((item) => {
      const project = projectNames.find((proj) => proj.project === item);
      return project ? project._id : null;
    });
  };

  const handleApprove = async () => {
    setLoading(true);
    let payload = { ...timeSheet };
    payload.status = getApprovalStatus(approvalStatus.current);
    payload.approvedDate = new Date();
    payload.isApprovedBy = getToken("Id");
    payload.comments = dialogComment;
    payload.projectId = getProjectID(payload.projectId);
    approvalStatus.current === "reject"
      ? (payload.isSubmitted = false)
      : (payload.isSubmitted = true);
    setLoading(false);
    try {
      let url = `${serviceUrl}/api/workLogManagement/updateworklog?workLogId=${timesheetId.current}`;
      let response = await axios.put(url, payload, {
        headers: genericHeaders(),
      });
      if (response.status === 200) {
        getEmployeelog(employeeFilter);
        setLoading(false);
        setDialogOpen(false);
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const handleWorklogSubmit = async (submitted, uploadData = null) => {
    setSubmitDialogOpen(false);
    let payload = { ...timeSheet };
    payload.employeeId = employeeFilter.employeeId;
    payload.isSubmitted = submitted;
    payload.currentMonth = employeeFilter.date;
    payload.status = submitted ? "SUBMITTED" : "DRAFT";
    if (uploadData) {
      const existingUploads = Array.isArray(payload.weeklyTimesheetUploads)
        ? payload.weeklyTimesheetUploads.filter(u => u.weekStartDate !== uploadData.weekStartDate)
        : [];
      payload.weeklyTimesheetUploads = [
        ...existingUploads,
        {
          weekStartDate: uploadData.weekStartDate,
          weekEndDate: uploadData.weekEndDate,
          billingHours: Number(uploadData.billingHours),
          description: uploadData.description,
          timesheetDocument: uploadData.timesheetDocument,
        },
      ];
    }
    setLoading(true);
    try {
      let response;
      if (timesheetId.current) {
        response = await axios.put(
          `${serviceUrl}/api/workLogManagement/updateworklog?workLogId=${timesheetId.current}`,
          payload,
          { headers: genericHeaders() }
        );
      } else {
        response = await axios.post(
          `${serviceUrl}/api/workLogManagement/create`,
          payload,
          { headers: genericHeaders() }
        );
      }
      if (response.status === 200 || response.status === 201) {
        toast.success(submitted ? "Timesheet submitted successfully" : "Timesheet saved successfully");
        getEmployeelog(employeeFilter);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error("Something went wrong");
      console.error(err);
    }
  };

  const maxDate = dayjs().endOf("month");

  const displayMonth = dayjs(employeeFilter.date).format("MMMM");

  const handleDialog = (status) => {
    approvalStatus.current = status;
    setDialogComment("");
    setDialogOpen(true);
  };

  const getIsEditable = () => {
    return timeSheet?.status !== "APPROVED";
  };

  const isFillOnBehalfMode =
    isAdminUser &&
    (!timeSheet?.status ||
      timeSheet.status === "DRAFT" ||
      timeSheet.status === "REJECTED");

  const ownerName = employees.find((emp) => emp.employeeId === employeeFilter.employeeId)?.name;
  const submitter = getActorInfo({
    actorId: timeSheet?.submittedBy,
    actorName: timeSheet?.submittedByName,
    actorRole: timeSheet?.submittedByRole,
    ownerId: timeSheet?.employeeId || employeeFilter.employeeId,
    ownerName,
  });

  const renderContent = () => {
    if (dataNotAvailable) {
      return (
        <p className="text-center text-2xl mt-44">
          Data not available for the selected month
        </p>
      );
    }

    if (
      !employeeFilter?.employeeId ||
      !employeeFilter?.date ||
      weekData.length === 0
    ) {
      return (
        <p className="text-center mt-20 text-3xl">
          Please select the employee and the month.
        </p>
      );
    }
      if (timeSheetError && timeSheetErrorData?.status !== 409) {
        return (
          <>
            <section className="flex flex-col mx-auto items-center mt-[25vh]">
              <p className="font-semibold">
              {timeSheetErrorData?.data?.message ? timeSheetErrorData?.data?.message : "Something Went Wrong please try agin Later"}
              </p>
            </section>
          </>
        );
      } else if (!timeSheetLoading) {
        return (
          <>
            <h2 className="text-center font-semibold text-2xl my-5">
              Time Sheet for the month of {displayMonth}
            </h2>

            <div className="flex mx-auto justify-end w-[90%] my-2">
              {/* <div className="w-1/2">
              <p className="text-2xl whitespace-normal">
                Projects: <span>{timeSheet?.projectId.join(",")}</span>
              </p>
            </div> */}
              {timeSheet?.status !== "DRAFT" ? (
                <>
                  <div className="flex">
                    <p className="text-2xl">Status: {timeSheet?.status}</p>
                  </div>
                </>
              ) : (
                <div className="text-xl text-red-600">Yet to submit</div>
              )}
            </div>

            {timeSheet?.submittedBy && timeSheet?.status && timeSheet.status !== "DRAFT" && (
              <p className="w-[80%] mx-auto mb-2 text-base text-gray-600">
                Submitted by <span className="font-semibold">{submitter.actorName}</span>
                {submitter.roleLabel ? ` (${submitter.roleLabel})` : ""}
                {submitter.isOnBehalf ? ` on behalf of ${ownerName || "the employee"}` : ""}
                {formatActorDate(timeSheet?.submittedOn) ? ` on ${formatActorDate(timeSheet?.submittedOn)}` : ""}
                {submitter.isOnBehalf && (
                  <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 border border-blue-300" style={{ marginLeft: 8 }}>
                    On behalf
                  </span>
                )}
              </p>
            )}

            {weekData.map((item, weekIndex) => (
              <WeekCard
                key={weekIndex}
                item={item}
                isEditable={getIsEditable()}
                daysVisible={daysVisible}
                weekIndex={weekIndex}
                toggleDaysVisibility={toggleDaysVisibility}
                datesData={datesData}
                getLogHoursValue={getLogHoursValue}
                getCommentsValue={getCommentsValue}
                timeSheet={timeSheet}
                setTimeSheet={setTimeSheet}
                month={employeeFilter.date}
                handleCommentChange={handleCommentChange}
                handleHourChange={handleHourChange}
                handleSubmit={isFillOnBehalfMode ? handleWorklogSubmit : handleApprove}
                isAdmin={!isFillOnBehalfMode}
                projectId={projectId}
                projects={projects}
                handleProjects={handleProjects}
                timeSheetDatesData={timeSheetDatesStatus}
                weeklyTimesheetUploads={timeSheet?.weeklyTimesheetUploads ?? []}
              />
            ))}

            <div className={`flex justify-end mx-auto w-4/5 mt-7 space-x-3`}>
            {shoulShowBackButton && <button className='bg-blue-500 text-white font-semibold py-1 px-2 rounded' onClick={()=>navigate('/allReview')}>Back</button>}
            {timeSheet?.status === "SUBMITTED" && (
              <>
                <button
                  className="bg-red-500 hover:bg-white hover:text-red-500 border border-red-500 text-white font-semibold py-1 px-2 rounded"
                  onClick={() => handleDialog("reject")}
                  >
                  Reject
                </button>
                <button
                  className="bg-green-500 hover:bg-white hover:text-green-500 border border-green-500 text-white font-semibold py-1 px-2 rounded"
                  onClick={() => handleDialog("approve")}
                  >
                  Approve
                </button>
              </>
            )}
            {isFillOnBehalfMode && projectId?.length > 0 && (
              <button
                className="bg-blue-500 hover:bg-white hover:text-blue-500 border border-blue-500 text-white font-semibold py-1 px-2 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={() => setSubmitDialogOpen(true)}
                disabled={!timesheetId.current}
              >
                Submit
              </button>
            )}
              </div>
          </>
        );
      }
  };

  useEffect(() => {
    getEmployeeData();
    getProjectData();
  }, []);

  useEffect(() => {
    if (employeeFilter.date && employeeFilter.employeeId) {
      const weeks = generateWeeks(employeeFilter.date);
      const days = generateDates(weeks);
      setWeekData(weeks);
      setDatesData(days);
      setDaysVisible(Array(weeks.length).fill(false));
      let startDate = dayjs(employeeFilter.date).startOf('month').format('YYYY-MM-DD');
      let endDate = dayjs(employeeFilter.date).endOf('month').format('YYYY-MM-DD');
      const payload = {
        "employeeId": employeeFilter.employeeId,
        "fromDate": startDate,
        "toDate": endDate
      }
      getTimesheetDatesStatus(payload)
    }
  }, [employeeFilter.date, employeeFilter.employeeId]);

  useEffect(()=>{
    if(timeSheetError){
      setTimeSheetErrorData(error)
      error.status === 409 && toast.info('PaySlip has already been Generated for this month')
    }
    if(timesheetDatesData){
      setTimeSheetDatesStatus(timesheetDatesData.data)
    }
  },[timesheetDatesData, error, timeSheetError])
  useEffect(() => {
    if(timesheetdata){
      const [id, timestamp] = timesheetdata.split(":");
      const newState = {
        employeeId: id,
        date: timestamp+":00:00.000Z",
      }
      setEmployeeFilter(newState)
      getEmployeelog(newState)
      getProjectDataByEmpId(id)
    }
  }, [timesheetdata]);

  useEffect(()=>{
    if(count<2 && employeeFilter && projects && timesheetdata){
      setCount(prev=> prev++)
      getEmployeelog(employeeFilter)
    }
  },[employeeFilter, projects])
  return (
    <>
      {loading && <Loader />}
      <section className="mt-20">
        <div className="mt-28 mx-10">
          <section className="flex space-x-5">
            <div className="flex flex-row w-1/2">
              <h4 className="text-lg my-auto">Select Employee: </h4>
              <select
                name="employeeId"
                value={employeeFilter.employeeId}
                onChange={handleFilter}
                className={`border border-slate-300 rounded-md py-1 h-8 px-3 w-60 ml-5`}
              >
                <option disabled={true} value="">
                  -- Select an option --
                </option>
                {employees.map((option) => (
                  <option key={option.employeeId} value={option.employeeId}>
                    {option.name}
                  </option>
                ))}
              </select>
            </div>
            {employeeFilter.employeeId !== "" ? (
              <div className="flex flex-row w-1/2">
                <h4 className="text-lg my-auto">Select Month: </h4>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={
                      employeeFilter.date ? dayjs(employeeFilter.date) : null
                    }
                    openTo="month"
                    views={["month", "year"]}
                    onChange={handleFilter}
                    maxDate={maxDate}
                    sx={{
                      maxHeight: 30,
                      width: "15rem",
                      bgcolor: "white",
                      marginTop: "auto",
                      marginBottom: "auto",
                      marginLeft: "1.25rem",
                      "& .MuiInputBase-root": {
                        height: 30,
                      },
                      borderRadius: "0.375rem",
                    }}
                  />
                </LocalizationProvider>
              </div>
            ) : (
              <></>
            )}
          </section>

          <section className="mb-5 space-y-5 mx-auto">
            {renderContent()}
          </section>
        </div>
      </section>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent className="space-y-3">
          <p className="text-2xl font-semibold">
            Are you sure you want to {approvalStatus.current} this timesheet?
          </p>
          <div className="w-full">
            <p className="text-base">
              Please add your comments here, if you have any.
            </p>
            <textarea
              value={dialogComment}
              onChange={(e) => setDialogComment(e.target.value)}
              className="border w-full rounded-md px-2"
              placeholder="Enter your comments here"
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>CANCEL</Button>
          <Button onClick={() => handleApprove()}>
            {String(approvalStatus.current).toUpperCase()}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={submitDialogOpen}
        onClose={() => setSubmitDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <p className="text-2xl font-semibold">
            Are you sure you want to submit this timesheet?
          </p>
          <p className="text-sm text-red-500 py-2">
            Kindly be aware that once submitted, the timesheet cannot be edited.
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSubmitDialogOpen(false)}>CANCEL</Button>
          <Button onClick={() => handleWorklogSubmit(true)}>SUBMIT</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default AdminWorkLog
